import { Collection, ContentObject } from '@varos/research-sdk-api';
import { RecordFormValues } from './recordFormInterface';

export function buildDefaultFormValues(item: {
    collection: Collection;
    record: ContentObject | null;
}): RecordFormValues {
    return {
        title: item.record?.title ?? null,
        properties: item.collection.properties.reduce((acc, property) => {
            let value: unknown | null = item.record?.properties[property.key] ?? null;

            // Only set default generated value if there's no existing value
            if (
                value === null &&
                (property.type === 'datetime' || property.type === 'date') &&
                property.formula?.kind === 'current_timestamp'
            ) {
                value = new Date();
            }

            return { ...acc, [property.key]: value };
        }, {}),
    };
}
